import CSVUploadStep from '../CSVUploadStep/CSVUploadStep';
import { useCustomPacingScheduleContext } from '../CustomPacingScheduleProvider/CustomPacingScheduleProvider';
import InitialStep from '../InitialStep';
import ReportList from '../ReportList';
import ResultStep from '../ResultStep/ResultStep';
import ScheduleStep from '../ScheduleStep';
import { Step } from '../types';

type Props = {
  lineItemIdList: string[];
};

const CustomPacingStepper = ({ lineItemIdList }: Props): React.JSX.Element => {
  const { step } = useCustomPacingScheduleContext();

  switch (step) {
    case Step.Initial:
      return <InitialStep />;
    case Step.SetCPSchedule:
      return <ScheduleStep lineItemIdList={lineItemIdList} />;
    case Step.CSVUpload:
      return <CSVUploadStep />;
    case Step.Result:
      return <ResultStep />;
    case Step.ReportList:
      return <ReportList />;
    default:
      return <InitialStep />;
  }
};

export default CustomPacingStepper;
